<template>
  <b-modal
    :no-close-on-backdrop="true"
    :id="modalId"
    :title="$t('common.delete-item')"
    ok-only
    :ok-title="$t('common.delete')"
    @ok="handleDelete"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <b-card-text>
      <h5>{{ $t('common.delete-sure') }}</h5>
      {{ $t('common.sure-click') }}
    </b-card-text>
  </b-modal>
</template>

<script>
import { BModal, BCardText } from 'bootstrap-vue';
export default {
  components: {
    BModal,
    BCardText,
  },
  props: ['modalId'],
  data() {
    return {};
  },
  methods: {
    handleDelete() {
      this.$emit('deleteToggle');
      this.$bvModal.hide(this.modalId);
    },
    onModalShown() {
      // Add global keydown listener when modal is shown
      document.addEventListener('keydown', this.handleKeydown);
    },
    onModalHidden() {
      // Remove global keydown listener when modal is hidden
      document.removeEventListener('keydown', this.handleKeydown);
    },
    handleKeydown(event) {
      // Check if Enter key is pressed and modal is visible
      if (event.key === 'Enter' || event.keyCode === 13) {
        const modal = document.getElementById(this.modalId);
        if (modal && modal.style.display !== 'none') {
          this.handleDelete();
        }
      }
    }
  },
  beforeDestroy() {
    // Clean up event listener if component is destroyed
    document.removeEventListener('keydown', this.handleKeydown);
  }
};
</script>
